define('commons/field-validation-errors',{

    /**
     * Add an error to a field. The field must be a jquery element
     */
    addError: function(field, key, text) {
        var errors = field.data('errors') || {};
        errors[key] = text;
        field.data('errors', errors);
    },

    /**
     * Remove an error from a field. The field must be a jquery element
     */
    removeError: function(field, key) {
        var errors = field.data('errors') || {};
        delete errors[key];
        field.data('errors', errors);
    },

    /**
     * Update the title containing all the errors of a field. The field must be a jquery field.
     */
    updateErrors: function(field) {
        var errors = field.data('errors');
        var text = '';
        for ( var error in errors) {
            if (text.length > 0) {
                text += ', ';
            }
            if (errors.hasOwnProperty(error)) {
                text += errors[error];
            }
        }
        field.attr('title', text);
    }
});
